import { MapPin, Clock, Banknote, Heart, Calendar } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { formattedDate } from "../../../helpers";

const JobCard = ({ job }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 mb-4 shadow-sm hover:shadow-md transition-shadow duration-300">
      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex items-center flex-1">
          <img src={job?.coverMedia?.url} alt={`${job?.title} company logo`} className="w-20 h-20 rounded-lg border border-gray-200 flex-shrink-0" />
          <div className="ml-4 flex-1">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">{job?.title}</h3>
            <div className="flex flex-wrap gap-4 text-sm text-gray-600">
              <span className="flex items-center">
                <MapPin className="w-5 h-5 text-emeraldPrimary mr-2" />
                {job?.location[0]?.defaultAddress
                  ? `${job?.location.find((loc) => loc.defaultAddress === true)?.city} , ${
                      job?.location.find((loc) => loc.defaultAddress === true)?.country
                    }`
                  : "Not specified"}
              </span>
              <span className="flex items-center">
                <Clock className="w-5 h-5 text-emeraldPrimary mr-2" />
                {job?.job?.jobType ? job?.job?.jobType.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "Not mentioned"}
              </span>
              <span className="flex items-center">
                <Banknote className="w-5 h-5 text-emeraldPrimary mr-2" />
                {job?.job?.budget
                  ? `${job?.job?.budget?.range?.unit === "usd" ? "$" : "₹"}${job?.job?.budget?.range?.min} - ${
                      job?.job?.budget?.range?.unit === "usd" ? "$" : "₹"
                    }${job?.job?.budget?.range?.max}`
                  : "TBD"}
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-start md:items-end justify-center gap-3">
          <div className="flex gap-3">
            <button className="w-12 h-12 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-lg flex items-center justify-center transition-colors duration-200">
              <Heart className="w-5 h-5 text-emeraldPrimary" />
            </button>
            <button
              className={`px-6 py-3 bg-${job?.applicationStatusDetail?"gray-400":"emeraldPrimary"} hover:bg-${job?.applicationStatusDetail?"gray-400":"emeraldPrimary"} text-white rounded-lg font-medium transition-colors duration-200`}
              onClick={() => navigate(`/user/job-apply?job=${job?.slug}-${job?.uid}`)}
              disabled={job?.applicationStatusDetail}
            >
              {
                job?.applicationStatusDetail?job?.applicationStatusDetail?.status.replace(/^\w/, c => c.toUpperCase()):"Apply Now"
              }
            </button>
          </div>
          <span className="flex items-center text-sm text-gray-500">
            <Calendar className="w-4 h-4 text-emeraldPrimary mr-2" />
            Posted On: {formattedDate(job?.createdAt)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default JobCard;
